// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__FUR29","controls":"styles_controls__3a3t1","charLimit":"styles_charLimit__LXK05","input":"styles_input__2YViP","send":"styles_send__QU9CO"};